import React, { Component } from "react";
import { connect } from "react-redux";
import { forgotPassword } from "../../../domain/auth/authActions";
import { closeModal } from "../../../domain/ui/uiActions";
import PasswordForgotInitialForm from "../../forms/public/PasswordForgotInitialForm";
import { FormattedMessage } from "react-intl";
class PasswordForgotInitial extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div>
				<div className="vr vr_x5">
					<h1 className="hdg">
						<FormattedMessage id="passwordForgotInitial.header" defaultMessage="Forgot Password"/>
					</h1>
				</div>
				{process.env.CLIENT === "CapOne" && (<div className="vr vr_x5">
				<div className="text">
						<FormattedMessage id="passwordForgotInitial.intro" defaultMessage="Send us your username (email address) with this form to retrieve your password." tagName="p"/>
					</div>
				</div>)}
				<div className="vr vr_x5">
					<div className="sides sides_x4S">
						<PasswordForgotInitialForm closeModal={this.props.closeModal} fieldErrors={this.props.authFieldErrors} forgotPassword={this.props.forgotPassword} isLoading={this.props.authIsLoading}/>
					</div>
				</div>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    authFieldErrors: state.auth.fieldErrors,
    authIsLoading: state.auth.isLoading
});
const bindActionsToProps = {
    closeModal,
    forgotPassword
};
/* Create and export container component that wraps PasswordForgotInitial for property binding */
export default connect(mapStateToProps, bindActionsToProps)(PasswordForgotInitial);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/modals/PasswordForgotInitial.tsx